import yup from 'src/libraries/validator.library';
import {
  IOperatorTailForm,
  OperatorTailNumberPayloadSchema,
  OperatorTailListSchema,
} from 'src/models/operator-tail.model';
import { httpClient } from 'src/libraries/http.library';
// import { OperatorTails } from './mocks/operator-tail-number-relationship.mock';

const http = httpClient();

const services = {
  listGET: async () => {
    // return OperatorTails;
    return http.get('operatorTails', { limit: 0 }, OperatorTailListSchema);
  },
  updatePUT: async (id: number, data: IOperatorTailForm) => {
    return http.put(
      `operatorTails/${id}`,
      data,
      OperatorTailNumberPayloadSchema
    );
  },
  addPOST: async (data: IOperatorTailForm) => {
    return http.post('operatorTails', data, OperatorTailNumberPayloadSchema);
  },
  itemDELETE: async (id: number) => {
    return http.delete(`operatorTails/${id}`, yup.mixed());
  },
};

export default services;
